module.exports = __webpack_public_path__ + "static/media/Elegante-Logo.936a13a6.svg";